<template>
  <div>
        <span @click="search()">
            <Button type="primary" @click="operationReportModal = true" v-hasPermission="['operationKpiConfigurationManagement:operationReport:add_report']">{{$t('MCM.automaticalMaintenanceReport.add')}}</Button>
        </span>
    <Modal v-model="operationReportModal" :title="$t('MCM.automaticalMaintenanceReport.add')" :loading="loading"
           @on-ok="operationReportSubmit('operationReportForm')"
           @on-cancel="operationReportReset('operationReportForm')" :mask-closable="false"
           :okText="$t('alarms.common.add')" :cancelText="$t('alarms.common.cancel')">
      <Form ref="operationReportForm" :model="operationReportForm" :label-width="100" :rules="ruleValidate">
        <!-- 公司 -->
        <FormItem :label="$t('MCM.automaticalMaintenanceReport.companyName')" prop="company">
          <Select v-model="operationReportForm.company" style="width:300px;" :transfer="true"
                  @on-change="changeCompany(operationReportForm.company)">
            <Option :value="item.id" v-for="item in companyList" v-bind:key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>

        <!-- 账号  -->
        <FormItem :label="$t('MCM.automaticalMaintenanceReport.account')" prop="accountSearchKey">
          <Select v-model="operationReportForm.accountSearchKey" filterable multiple :max-tag-count="1" :placeholder="$t('MCM.automaticalMaintenanceReport.filterByAccount')" :transfer="true" @on-change="searchAccount(operationReportForm.accountSearchKey)" style="width: 300px;">
            <Checkbox v-model="singleAccount" @on-change="selectAccountAll" style="display: block;text-align:right;">{{$t('configuration_management.customized_alarm_config.checkAll')}}</Checkbox>
            <Option :value="item.id" v-for="item in accountList" :key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>

        <!-- 区域 -->
        <FormItem :label="$t('MCM.automaticalMaintenanceReport.region')" prop="regions">
          <Select v-model="operationReportForm.regions" multiple style="width:300px;">
            <Option v-for="item in regionsList" :value="item.key" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>

        <!-- 月份 -->
        <FormItem :label="$t('MCM.automaticalMaintenanceReport.month')" prop="yearMonth">
          <DatePicker type="month" :placeholder="$t('MCM.automaticalMaintenanceReport.pleaseSelectMonth')" v-model="operationReportForm.yearMonth" style="width:300px;"
                      @on-change="operationReportForm.yearMonth=$event" format="yyyy-MM"></DatePicker>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>
  import {setCookie, getCookie} from '../../../../utils/cookieUtil.js'
  import TableOperationReport from '../operation_report/TableOperationReport'

  var tableOperationReport = TableOperationReport;
  export default {
    data() {
      return {
        loading: true,
        operationReportModal: false,
        companyList: [],  // 公司
        singleAccount: false, // 账号
        regionsList: [],//区域
        accountList: [],
        operationReportForm: {
          company: '',
          yearMonth: '',
          accountSearchKey: [],
          regions: []
        },
        ruleValidate: {
          company: [
            {required: true, message: this.$t('MCM.automaticalMaintenanceReport.pleaseSelectCompany'), trigger: 'change', type: 'number'}
          ],
          yearMonth: [
            {required: true, message: this.$t('MCM.automaticalMaintenanceReport.pleaseSelectMonth')}
          ],
          accountSearchKey: [
            {required: true, type: 'array', message: this.$t('MCM.automaticalMaintenanceReport.pleaseSelectAccount')}
          ],
          regions: [
            {required: true, type: 'array', message: this.$t('MCM.automaticalMaintenanceReport.pleaseSelectRegion'), trigger: 'change'}
          ]
        }
      }
    },
    methods: {
      /************************查询条件**************************************/
      // 区域
      getRegionByAreaType: function () {
        this.$api.accountGroup.getRegionByAreaType("areaType", 1)
          .then(res => {
            this.regionsList = res.data;
          })
      },
      // 公司
      getCompanyDropDownBox: function () {
        this.$api.company.getCompanyDropDownBox("userName", getCookie(global.cookieName))
          .then(res => {
            this.companyList = res.data;
          })
      },
      // 切换公司
      changeCompany: function (val) {
        if (this.operationReportForm.company == undefined) {
          return;
        }
        this.operationReportForm.company = val;
        // 账号下拉框
        this.$api.account.queryAccountListByCompanyIdAndCloudType({
          "companyId": this.operationReportForm.company,
          "cloudPlatformType": 0
        })
          .then(res => {
            this.accountList = res.data;
          })
      },
      search: function () {
        this.singleAccount = false;
        this.getCompanyDropDownBox();
        this.getRegionByAreaType();
      },
      /***********账号**************************/
      selectAccountAll() {
        this.operationReportForm.accountSearchKey = [];
        if (this.singleAccount) {
          this.accountList.map((item) => {
            this.operationReportForm.accountSearchKey.push(item.id);
          })
        } else {
          this.operationReportForm.accountSearchKey = [];
        }
      },
      // 切换账号
      searchAccount: function (val) {
        if (val.length === this.accountList.length && val.length != 0) {
          this.singleAccount = true
        } else {
          this.singleAccount = false
        }
        //根据账号查询账号关联的区域
        this.$api.account.queryRegionsByAccounts("accountIds", val)
          .then(res => {
            this.regionsList = res.data;
          })
      },
      operationReportSubmit: function (name) {
        this.$refs[name].validate(valid => {
          if (valid) {
            // 添加
            this.$api.report.createReport({
              "accountIdList": this.operationReportForm.accountSearchKey,
              "companyId": this.operationReportForm.company,
              "reportDate": this.operationReportForm.yearMonth,
              "regions": this.operationReportForm.regions
            })
              .then(res => {
                setTimeout(() => {
                  tableOperationReport.methods.showAll();
                  this.$refs[name].resetFields();
                  this.loading = false;
                  this.$nextTick(() => {
                    this.loading = true;
                  });
                  this.$Message.success('添加成功');
                  this.accountList = [];
                  this.operationReportModal = false;
                }, 1000);
              })
          } else {
            this.loading = false;
            setTimeout(() => {
              this.loading = true
            }, 0)
            this.$Message.error('添加失败');
          }
        });
      },
      operationReportReset: function (name) {
        this.accountList = [];
        this.singleAccount = false;
        this.$refs[name].resetFields();
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/configuration/operation_kpi_configuration_management/operation_report/AddOperationReport.vue